export const NAME = '@KICK';

export const ACLs = {
  SYSTEM_ADMIN: 'SystemAdmin',
  ACCOUNT_AMDIN: 'BusinessAdmin',
  USER: 'User',
  PUBLIC: 'Public',
};
